import 'components/orderSummary/components/orderTotals/promoCodeLineItem.scss';
import { InputContainer } from 'components/inputContainer/inputContainer';
import template from './promoCodeLineItem.html';

export const PromoCodeLineItem = angular
    .module('checkout.components.volt.orderSummary.promoCodeLineItem', [
        InputContainer
    ]).component('voltPromoCodeLineItem', {
        template,
        bindings: {
            discount: '<',
            onRemovePromoClicked: '<',
            hideRemoveButton: '<'
        },
        controller: class PromoCodeLineItemCtrl {
            $onInit() {
                this.codeRequired = this.discount ? this.discount.discountCode : '';
                this.discountName = this.discount ? this.discount.name : '';
            }
            onRemoveClicked(discountCode) {
                this.isRemoving = true;
                this.onRemovePromoClicked(discountCode).finally(() => {
                    this.isRemoving = false;
                });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/newCheckout/components/orderSummary/components/discountLineItems/promoCodeLineItem.js